// extracted by mini-css-extract-plugin
export var dividerContainer = "_8p-0";
export var line = "_8p-1";